export default __webpack_public_path__ + "static/media/IMG_8857.5faadf79.jpg";